import React from "react";
import Select from "react-select";
import { sortObjectsByAlphabet } from "../../utils";

function ChooseDeviceField({ devices = [], value, onChange }) {

    const handleChange = async (selectedOption) => {
        let selectDevice = null;
        let sshAlgorithm = '';
        if (selectedOption && selectedOption.value > 0) {
            selectDevice = devices.find(device => device.id === Number(selectedOption.value));
            // const sshAlgorithmText = await additionalAlgorithmService.getDeviceSSHAlgorithm(id);
            if (selectDevice.sshAlgorithm) {
                sshAlgorithm = selectDevice.sshAlgorithm;
            } else {
                sshAlgorithm = '';
            }
        }

        let disabledButton = true;
        if (!selectDevice) {
            disabledButton = true;
        } else {
            disabledButton = false;
        }

        onChange(selectDevice, sshAlgorithm, disabledButton);
    }

    const devicesCopy = sortObjectsByAlphabet(devices, 'hostName');

    const options = devicesCopy
        ? devicesCopy.map((device) => ({
            value: device.id,
            label: device.hostName
        }))
        : [];

    return (
        <div className="oct_settings-field mb-3">
            <label className="oct_settings-label">Choose Device</label>
            <Select
                id="deviceName"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={value ? options.find(option => option.value === value.id) || null : null}
                onChange={handleChange}
                options={options}
                isSearchable
                placeholder="Choose"
                noOptionsMessage={() => "No devices available"}
                // isClearable
            />
        </div>
    );
}

export default ChooseDeviceField;
